import React from 'react';
import { EmptyStatesLayout } from '../Layout/EmptyStatesLayout';
import { NoContentComponent } from './NoContentComponent';

const { EmptyTableWrapper } = EmptyStatesLayout;

export const NoContentTableComponent = ({ hasActiveFilters, message, topic, searchTerm, isClaimsList }) => {
  return (
    <EmptyTableWrapper $isClaimsList={isClaimsList}>
      <NoContentComponent hasActiveFilters={hasActiveFilters} message={message} topic={topic} searchTerm={searchTerm} />
    </EmptyTableWrapper>
  );
};
